import Marionette from "backbone.marionette";
import $ from "jquery";
import _ from "lodash";

import templ from "../templates/questions";
import models from "../models/questions";

const QuestionView = Marionette.View.extend({
    id: null,
    getTemplate() {
        switch (this.model.get("type")) {
            case models.TYPE.SELECT_ONE:
                return templ.selectOne;

            case models.TYPE.CHOOSE_ONE:
            case models.TYPE.RATE_ONE:
            case models.TYPE.RATE_SATISFACTION:
                return templ.chooseOne;

            case models.TYPE.SHORT_ANSWER:
                return templ.shortAnswer;

            case models.TYPE.LONG_ANSWER:
                return templ.longAnswer;

            case models.TYPE.CHOOSE_MANY:
                return templ.chooseMany;

            case models.TYPE.FOLLOW_UP:
                return templ.followUp;

            default:
                break;
        }

        return null;
    },
    serializeData() {
        return _.extend(this.model.toJSON(), {
            hide: this.isHidden(),
        });
    },
    isHidden() {
        if (!this.options.hideClean) {
            return false;
        }

        if (this.model.shouldReprompt()) {
            return false;
        }

        return this.model.isClean();
    },
    companyName() {
        return this.model.get("company_name");
    },
    toggleHelp(data) {
        const self = this;
        const error = "This field is required";

        _.each(data, (val, id) => {
            let $el = $(`#${id}`);
            if ($el.length != 1) {
                $el = $(`input[name=${id}]`).first();
            }
            self.showError($el, val ? null : error);
        });
    },
    showError($el, error) {
        if (error) {
            $el.addClass("has-error");
            $el.parent().find(".help-block").html(error).removeClass("hidden");
        } else {
            $el.removeClass("has-error");
            $el.parent().find(".help-block").html("").addClass("hidden");
        }
    },
    getData() {
        const id = this.model.get("id");
        const data = {};
        let value = null;

        let $el = $(`#${id}`);

        if ($el.length == 1) {
            value = $el.val();
        } else {
            value = [];

            $el = $(`input[name=${id}]:checked`);
            _.forEach($el, (e) => {
                if ($(e).val()) value.push($(e).val());
            });

            if (_.includes(models.CHOICE_TYPES, this.model.get("type"))) {
                if (value.length == 1) {
                    value = value[0];
                } else {
                    value = null;
                }
            }
        }

        data[id] = value;
        this.model.set("response", value);

        if ($(`input[name=${id}].has-follow-up:checked`).length && $(`#${id}b`).length) {
            const followUp = $(`#${id}b`).val();
            data[`${id}b`] = followUp;
            this.model.set("follow_up_response", followUp);
        } else {
            this.model.set("follow_up_response", null);
        }

        this.toggleHelp(data);
        return this.model.toJSON();
    },
});

export default QuestionView;
